"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import deepEqual from 'fast-deep-equal';

const ELEMENT_KEY_PREFIX = "element:";
function stringifyElementKey({ type, selector, token }) {
  return `${ELEMENT_KEY_PREFIX}${JSON.stringify({
    type,
    token,
    selector
  })}`;
}
function parseElementKey(keyString) {
  try {
    const keyPayload = keyString.slice(ELEMENT_KEY_PREFIX.length);
    const parsed = JSON.parse(keyPayload);
    if (typeof parsed !== "object" || parsed === null || typeof parsed.type !== "string") {
      throw new Error("Invalid element key structure");
    }
    return parsed;
  } catch (error) {
    throw new Error(`Failed to parse element key: ${error instanceof Error ? error.message : "Unknown error"}`);
  }
}
function matchElementKey(keyString, query) {
  try {
    const key = parseElementKey(keyString);
    if (query.type !== void 0 && key.type !== query.type) {
      return false;
    }
    if (query.token !== void 0 && key.token !== query.token) {
      return false;
    }
    if (query.selector !== void 0 && !deepEqual(key.selector, query.selector)) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export { ELEMENT_KEY_PREFIX, matchElementKey, parseElementKey, stringifyElementKey };
